<template>
  <div class="px-[45] pt-[60] relative">
    <div class="text-center">
      <p class="t-[20] t-[#303133]">微信扫码登录</p>
      <p class="t-[14] t-[#606266] mt-[12] font-300">未注册的用户登录时将自动创建账号</p>
      <template v-if="!loading">
        <div class="relative w-[200] h-[200] mt-[28] mx-[auto]">
          <img class="w-[100%] h-[100%]" :src="qrcode" alt="" />
          <div v-if="status == 2" class="bg-[rgb(255,255,255,0.9)] w-[200] h-[200] absolute top-[0] left-[0] bottom-[0] right-[0]">
            <div class="flex h-[200] flex-col items-center justify-center cursor-pointer" @click="getWxAuthQrcode">
              <i class="icon t-[24] t-[#231815]">&#xe6f4;</i>
              <p class="mt-[14] t-[#000000] t-[12]">二维码已失效，点击刷新</p>
            </div>
          </div>
        </div>
        <div class="flex justify-center items-center mt-[20]">
          <img class="h-[18]" src="@/assets/img/public/wx_msg_icon.png" alt="" />
          <p class="t-[14] t-[#303133] ml-[4]" v-if="status == 1">扫码成功</p>
          <p class="t-[14] t-[#303133] ml-[4]" v-if="status == 0">
            请使用微信扫一扫&nbsp;&nbsp;<span class="t-[theme] cursor-pointer" @click="getWxAuthQrcode">刷新</span>
          </p>
          <p class="t-[14] t-[#303133] ml-[4]" v-if="status == 2">
            二维码已失效，<span class="t-[theme] cursor-pointer" @click="getWxAuthQrcode">点击刷新</span>
          </p>
        </div>
        <div class="t-[#909399] t-[14] text-center mt-[14] font-300">扫码注册视您已阅读并同意<a
              href="#/protocolRegister" target="_blank" class="!t-[theme] !no-underline">《注册协议》</a></div>
      </template>
      <template v-else>
        <div class="w-[200] h-[200] mt-[28] mx-[auto]">
          <img class="w-[100%] h-[100%]" :src="getCityAssetsFile('loading_wx_code.png')" alt="" />
        </div>
        <p class="t-[#303133] t-[14] mt-[20]">加载中...</p>
      </template>
    </div>
    <div class="flex items-center mt-[28]">
      <div class="flex-1 h-[1] bg-[#DFE2E9]"></div>
      <p class="mx-[10] t-[#C0C4CC] t-[14]">其它登录方式</p>
      <div class="flex-1 h-[1] bg-[#DFE2E9]"></div>
    </div>
    <div class="flex justify-center items-center mt-[32]">
      <div class="text-center cursor-pointer" @click="handleLoginByType(0)">
        <img class="w-[44] h-[44]" :src="getCityAssetsFile('pwd_icon.png')" alt="" />
        <p class="mt-[10] t-[12] t-[#606266] font-300">密码登录</p>
      </div>
      <div class="text-center cursor-pointer mx-[70]" @click="handleLoginByType(1)">
        <img class="w-[44] h-[44]" :src="getCityAssetsFile('code_icon.png')" alt="" />
        <p class="mt-[10] t-[12] t-[#606266] font-300">验证码登录</p>
      </div>
      <div class="text-center cursor-pointer" @click="handleLoginByType(2)">
        <img class="w-[44] h-[44]" :src="getCityAssetsFile('ca_icon.png')" alt="" />
        <p class="mt-[10] t-[12] t-[#606266] font-300">CA登录</p>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  name: "loginByWxScan",
  data() {
    return {
      authcode: "",
      qrcode: "",
      loading: true,
      timer: null,
      status: 0, // 0 等待扫码， 1 扫码成功， 2 扫码失败
    };
  },
  components: {},
  methods: {
    handleLoginByType(t) {
      this.$emit("handleLogint", t);
      this.timer && clearInterval(this.timer);
      this.timer = null;
    },
    getWxAuthQrcode() {
      this.authcode = "";
      this.loading = true;
      ajax.post({
        url: "/customer/common/createWxappletMobileAuthQrcode",
        data: {},
        self: this,
        success: (res) => {
          this.loading = false;
          if (res) {
            this.authcode = res.authcode;
            this.qrcode = res.qrcode;
            this.status = 0;
            this.handleStartQueryWxAuthQrCodeStatus();
          }
        },
        fail: (err) => {
          this.loading = false;
          console.log("err", err);
        },
      });
    },
    // 获取微信扫码状态
    getWxAuthQrcodeStatus() {
      if (!this.authcode) return;
      ajax.post({
        url: "/customer/auth/scanQrcodeWxappletMobileAuthLoginOrRegist",
        data: { authCode: this.authcode },
        self: this,
        success: (res) => {
          console.log("res", res);
          this.status = res.result;
          if (this.status == 1) {
            this.getCurrent();
          }
        },
        fail: (err) => {
          console.log("err", err);
        },
      });
    },
    /**
     * @author 伟健 / 张
     * @name 用户信息
     */
    getCurrent() {
      ajax.post({
        url: "/customer/user/current",
        data: {},
        self: this,
        success: (res) => {
          if (res && res.user) {
            localStorage.setItem("current", JSON.stringify(res));
            if(this.$route.query.type == "loanApply"){
              this.push({ path: "/loan/apply" });
            }else{
              this.push({ path: "/" });
            }
          }
        },
      });
    },
    // 开始查询微信扫码状态
    handleStartQueryWxAuthQrCodeStatus() {
      this.timer && clearInterval(this.timer);
      this.timer = null;
      this.timer = setInterval(() => {
        this.getWxAuthQrcodeStatus();
      }, 3000);
    },
  },
  created() {
    this.getWxAuthQrcode();
  },
  mounted() {},
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
    this.timer = null;
  },
  destroyed() {
    this.timer && clearInterval(this.timer);
    this.timer = null;
  }
};
</script>
<style scoped lang="less">
// @import "~@/assets/css/var.less";

.font-300 {
  font-weight: 300;
}

</style>
